import './beckersDemand.css'
import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { useSelector, useDispatch } from 'react-redux';
import { InputText } from "primereact/inputtext";
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Checkbox } from "primereact/checkbox";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Speaker from '../../Speakers';

import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";





import MarkupViewer from '../../MarkupViewer';
import FileUploader from '../../FileUploader'
import MarkupChanger from '../../MarkupChanger';
import FormBuilder from '../../FormBuilder';
import LayoutChanger from '../../LayoutChanger';
import { setLPDetails } from '../../../slices/createLPSlice';
import { useLocation } from 'react-router-dom';
import { LandingPageServe } from '../../../services/api/LandingPageServ';
const BeckersTemplate = () =>{
      const toast = useRef(null);
      const lpDetails = useSelector((state) => state.createLp.data);
      const isEditable = useSelector((state) => state.auth.isEditable);
      const isLogged = useSelector((state) => state.auth.isLogged);
      const dispatch = useDispatch();
      const [routerUrl , setRouterUrl] = useState('')
      const [editMode, setEditMode] = useState(isEditable);
      const [currentEditSection, setCurrentEditSection] = useState('');
      const [viewUploader, setViewUploader] = useState(false);
      const [viewEditor, setViewEditor] = useState(false);
      const [viewFormBuilder, setViewFormBuilder] = useState(false);
      const [viewLayoutChanger, setViewLayoutChanger] = useState(false)
      const [layout, setLayout] = useState(lpDetails.lplayout);
      const [templateNo , setTemplateNo] = useState(lpDetails.templateNo);
      const [content, setContent] = useState(null)
      const [markup, setMarkup] = useState('');
      const location = useLocation();
      const [emailLayout, setemailLayout] = useState(lpDetails.emaillayout);
         const [checked, setChecked] = useState(true); 
      // const [formFields , setformFields] = useState(lpDetails.fields);
      // const [isWebinar, setisWebinar] = useState(false);
    const [showSpeakerPopup, setShowSpeakerPopup] = useState(false);
      const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error"  style={{ display : "flex" , marginTop:'2px',marginBottom : "0px"  }}>{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
      };
    
    

    
    
      const {
        formState: { errors },
        handleSubmit,
        control,
        reset
      } = useForm();
    
      const {
        fields: itemFields,
        append: appendItem,
        remove: removeItem
      } = useFieldArray({
        control,
        name: "Items"
      })
    
    
    
      useEffect(() => {
        // console.log(lpDetails)
        setRouterUrl(location.pathname);
        if (isLogged) {
          setEditMode(isEditable)
        } else {
          setEditMode(false)
        }
    
        if (lpDetails._id) {
          setLayout(lpDetails.lplayout);
          setTemplateNo(lpDetails.templateNo);
          // setformFields(lpDetails.fields);
          document.title =lpDetails['lplayout']['title']['text'];
        }
        if (lpDetails.fields.length > 0) {
          reset()
          for (const f of lpDetails.fields) {
            appendItem(f)
          }
        }
        // console.log("Speakers updated:", layout.speakers);
      }, [lpDetails])
    

      const handleRemoveSpeaker = (index) => {
  const updatedSpeakers = layout.speakers.filter((_, i) => i !== index);
  const updatedLayout = { ...layout, speakers: updatedSpeakers };
  setLayout(updatedLayout);
  dispatch(setLPDetails({ lplayout: updatedLayout }));
};
    
      const handleDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
    
        const items = Array.from(itemFields);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        dispatch(setLPDetails({ fields: items }));
    }; 
    
      const dispatchLayout = (obj) => {
        dispatch(setLPDetails({ lplayout: { ...layout, ...obj , ...templateNo } }));
      }
    
      const dispatchEmailLayout=(obj) => {
        let footerObj = {}
        if(obj['headerLogo']){
          footerObj = {footerLogo:{ url: obj.headerLogo.url}}
          setLPDetails({emaillayout: {...emailLayout , ...footerObj}})
        } 
        dispatch(setLPDetails( { emaillayout: { ...emailLayout, ...obj , ...templateNo }}))
      }
      const dispatchFields = (data) => {
        dispatch(setLPDetails({ fields: [...itemFields, ...[data]] }))
      }
    
      const onFormSubmit = async (data) => {
        try {
          delete data['Items']
          if (!isEditable) {
            await LandingPageServe.saveform({ lpId: lpDetails._id, lead: data });
          }
          reset()
          toast.current.show({ severity: 'success', summary: 'Success', detail: 'Submitted successfully' });
          if(layout.webinarType === 'liveWebinar'){
             document.getElementById('formBC').style.display = 'none';
             document.getElementById('con-msg-div').style.display = 'block';
             window.scroll(0,0);
          } else {
           window.open(lpDetails.assetLink,"_self")
          }
         
        } catch (error) {
          // console.log(error);
          toast.current.show({ severity: 'error', summary: 'Error', detail: error.message });
    
        }
      };
    
      const handleClick = (type) => {
        setCurrentEditSection(type)
        if (type === 'HEADER_LOGO' || type === 'HERO_IMAGE' || type === 'FOOTER_LOGO') {
          setViewUploader(true);
        
        }
        if (type === 'TITLE') {
          setContent(layout.title)
          setViewLayoutChanger(true)
        }
        if (type === 'FORM_TITLE') {
          setContent(layout.formDisclaimer)
          setViewLayoutChanger(true)
        }
    
        if (type === 'HERO_CONTENT') {
          setMarkup(layout.heroContent)
          setViewEditor(true)
        }
        if (type === 'ACTION_BTN') {
          setContent(layout?.actionButton)
          setViewLayoutChanger(true)
        }
        if (type === 'FOOTER_CONTENT') {
          setMarkup(layout.footerContent);
          setViewEditor(true)
        }
      };
    
      const handleAdd = () => {
        setViewFormBuilder(true)
      };
    
      const handleRemove = (i) => {
        removeItem(i)
        const updatedFields = lpDetails['fields'].filter((ele,e)=> ele['name'] !== lpDetails['fields'][i]['name']);
        dispatch(setLPDetails({ fields: [...updatedFields]}));
      };
    
      const handleCloseEditor = (data , isWebinar , duration , webinarTitle,webinarType , liveWebinarTitle , speakersFlag) => {
        // console.log(isWebinar , duration , webinarTitle,webinarType , liveWebinarTitle , speakersFlag);
        let obj = {}
        if (currentEditSection === 'HERO_CONTENT') {
          obj = { 
            heroContent: data ,
            isWebinar : isWebinar || false,
            duration : duration || null,
            webinarTitle :webinarTitle || null,
            webinarType : webinarType || null,
            liveWebinarTitle : liveWebinarTitle || null,
            speakersFlag : speakersFlag || false
          }

         
    
          // setisWebinar(isWebinar);
        }
        if (currentEditSection === 'FOOTER_CONTENT') {
          obj = { footerContent: data }
        }
    
        
       
    
        setViewEditor(false)
        dispatchLayout(obj);
        // dispatchEmailLayout(obj);
      }
    
      const handleCloseUploader = (data,width,height) => {
        // console.log(width,height);
        if (data) {
          
          let obj = {}
          if (currentEditSection === 'HEADER_LOGO') {
            obj = { headerLogo: { url: data.Location , 
                                  width : width ||  '420px', 
                                  height : height || 'auto'} 
                  }
                 
                 
          }
          if (currentEditSection === 'HERO_IMAGE') {
            obj = { heroImage: { url: data.Location , 
                                width : width || '360px' , 
                                height : height || 'auto'} 
                  }
                 
          }
          if (currentEditSection === 'FOOTER_LOGO') {
            obj = { footerLogo:{ url: data.Location , 
                                  width : width || '250px' , 
                                  height :height || 'auto'} 
                  }
          }
          dispatchLayout(obj);
          // dispatchEmailLayout(obj);
        }
        setViewUploader(false)
      }
    
      const handleCloseBuilder = (data) => {
        setViewFormBuilder(false);
        if (data && Object.keys(data).length > 0) {
          appendItem(data);
          dispatchFields(data)
        }
      }
    
    
      const handleCloseLayoutChanger = (data) => {
        // console.log(data);
        let obj = {}
        if (data) {
          if (currentEditSection === 'TITLE') {
            obj = {
              title: {
                text: data.text,
                backgroundColor: data.backgroundColor,
                textColor: data.textColor,
                subtitle : data.subtitle
              }
            }
          }
          if (currentEditSection === 'ACTION_BTN') {
            obj = {
              actionButton: {
                text: data.text,
                backgroundColor: data.backgroundColor,
                textColor: data.textColor,
                link: data.link
              }
            }
          }
          if (currentEditSection === 'FORM_TITLE') {
            obj = {
              formDisclaimer: {
                text: data.text,
                backgroundColor: data.backgroundColor,
                textColor: data.textColor,
                link: data.link
              }
            }
          }
          dispatchLayout(obj)
          // dispatchEmailLayout(obj);
        }
        setViewLayoutChanger(false)
      }
    
      const getAddRemove = (i) => {
        return (
          <>
            <FaCircleMinus onClick={(() => handleRemove(i))} className='mt-3' style={{ color: "red" , cursor :'default' }} />
            {(itemFields.length - 1) === i && <FaCirclePlus onClick={(() => handleAdd())} className='mt-3 ml-2' style={{ color: "green" , cursor :'default' }} />}
    
          </>
        )
      }
    
      const getField = (item, i) => {
        return (
          <>
           {item.type !== 'check' &&
            <div>
                                   <label className='field-label'>{item?.label}</label>
                              </div>
    
      }
            
            {
              item.type === 'text' &&
             
              <span className='field'>
               
                <div className="flex justify-content-center" style={{ height: "45px" , marginTop : '5px'  }}>
                  <Controller
                    name={item.name}
                    control={control}
                    rules={{ required: item.message }}
                    render={({ field, fieldState }) => (
    
                      <>
                         {/* <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>  */}
                       
                        <span className='w-336-bc'>
                      
                          <InputText id="text"   value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                        </span>
                      </>
                    )}
                  />
                  <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                    {editMode && <div >{getAddRemove(i)}</div>}
                  </div>
                </div>
                <span>{getFormErrorMessage(item.name)}</span>
              </span>
    
            }
            {
              item.type === 'select' &&
             <span style={{marginTop : '5px'}}>
    
              
              <span className='field'>
    
                <div className="flex justify-content-center" key={item.id} style={{paddingLeft : '24px',height : '45px'}}>
             
                  <Controller
                   style={{width:'100% !important'}}
                    id="dropdown"
                    name={item.name}
                    control={control}
                    rules={{ required: item.message }}
                    render={({ field, fieldState }) => (
                      <>
                          
                          <Dropdown
                            id={field.name}
                            value={field.value}
                            optionLabel="label"
                            // placeholder={item.label}
                            options={item.options}
                            focusInputRef={field.ref}
                            onChange={(e) => field.onChange(e.value)}
                            className={classNames({ 'p-invalid': fieldState.error })}
                          />
                      </>
    
                    )}
                  />
    
                  <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                    {editMode && <div>{getAddRemove(i)}</div>}
                  </div>
                </div>
                <span>{getFormErrorMessage(item.name)}</span>
              </span>
             </span>
            }
            {
              item.type === 'number' &&
              <span className='field'>
                <div className="flex justify-content-center" style={{ height: "45px" , marginTop : '5px'  }} >
                  <Controller
                    name={item.name}
                    control={control}
                    rules={{ required: item.message ,  minLength: {
    value: 5,
    message: "Please enter at least 5 digits"
  },
  maxLength: {
    value: 10,
    message: "Please enter at most 10 digits"
  },
  pattern: {
    value: /^[0-9]+$/,
    message: "Please enter only numbers"
  }}}
                    render={({ field, fieldState }) => (
                      <>
                        {/* <label htmlFor={field.name}  className={classNames({ 'p-error': errors.value })}></label> */}
                        <span className='w-336-bc'>
                          
                          <InputText keyfilter="int" id={field.name} value={field.value}  className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                          {/* <label htmlFor={field.name}>{item.label}*</label> */}
                        </span>
                      </>
                    )}
                  />
                  <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                    {editMode && <div>{getAddRemove(i)}</div>}
                  </div>
                </div>
                <span>{getFormErrorMessage(item.name)}</span>
              </span>
            }
            {
  item.type === 'email' &&
  <span className="field">
    <div
      className="flex justify-content-center"
      style={{ height: "45px", marginTop: "5px" }}
    >
      <Controller
        name={item.name}
        control={control}
        rules={{
          required: item.message,
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid email address"
          }
        }}
        render={({ field, fieldState }) => (
          <>
            <span className="w-336-bc">
              <InputText
                id={field.name}
                value={field.value}
                type="email"
                className={classNames({ 'p-invalid': fieldState.error })}
                onChange={(e) => field.onChange(e.target.value)}
              />
            </span>
          </>
        )}
      />
      <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
        {editMode && <div>{getAddRemove(i)}</div>}
      </div>
    </div>

    <span>{getFormErrorMessage(item.name)}</span>
  </span>
}

            {
              item.type === 'check' &&
              <span className='field'>
                <div className="flex justify-content-center" style={{ width: "100%" , height: "auto" , marginTop : '0px' , padding : '0px 20px' }}>
                  <Controller
                    name={item.name}
                     defaultValue={true}
                    control={control}
                    rules={{ required: item.message }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.checked })}></label>
                           <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                      </>
                    )}
                  />
                  <label htmlFor="ingredient1" className="ml-2 opt-in"><MarkupViewer htmlString={item.label}></MarkupViewer></label>
                  <div className={`${itemFields.length - 1 === i  && editMode ? 'ml-2' : 'ml-5'}`}>
                    {editMode && <div className='check'>{getAddRemove(i)}</div>}
                  </div>
                </div>
                <span>{getFormErrorMessage(item.name)}</span>
              </span>
            }
          </>
    
        )
      }
    
      return (
        <>
          <Toast ref={toast}></Toast>
          <div className="container">
            <div className="row headerLogoBDC">
              <div
                className={`md:col-offset-0 md:col-12 col-12 text-left  ${
                  editMode ? "u-hover--sparkle" : ""
                }`}
                onClick={
                  editMode ? () => handleClick("HEADER_LOGO") : undefined
                }
                style={{paddingLeft : '50px'}}
              >
                <img
                  style={{
                    width: layout?.headerLogo?.width || "420px",
                    height: layout?.headerLogo?.height || "auto",
                  }}
                  src={layout?.headerLogo?.url}
                  alt="Header logo"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6" style={{ padding: "0px 0px 15px 50px" }}>
                <div>
                  {/* <div className={`md:col-offset-1 md:col-5 col-12 text-left ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('TITLE')) : undefined}> */}
                  <div
                    className={`md:col-12 text-left ${
                      editMode ? "u-hover--sparkle" : ""
                    }`}
                    onClick={editMode ? () => handleClick("TITLE") : undefined}
                  >
                    <h1
                      style={{
                        color: layout?.title?.textColor || "#003366",
                        width: "90% !important",
                        margin : '20px 0px 0px -8px',
                        fontSize : '26px'
                      }}
                    >
                      {layout?.title?.text}{" "}
                    </h1>
                    {layout?.title?.subtitle ? (
                      <p
                        style={{
                          color: layout?.title?.textColor || "white",
                          width: "90% !important",
                        }}
                      >
                        {layout?.title?.subtitle}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <hr className='borderBC'/>
                  {(layout?.webinarType === 'liveWebinar' && layout?.liveWebinarTitle !== null) && (
                    <h1 style={{color : layout?.title?.textColor || "#003366", fontSize : '24px'}}>{layout?.liveWebinarTitle}</h1>
                  )}
                    <div style={{fontSize : "20px"}} className={` md:col-12 text-left ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_CONTENT')) : undefined}>
           
            <MarkupViewer htmlString={layout?.heroContent} ></MarkupViewer>
          </div>

          {!layout?.speakersFlag && 
           <div className="presenters">
                  <div className={`md:col-5 col-12 text-left pdi-0 ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_IMAGE')) : undefined} >
            <img className="simgBC" style={{width : layout?.heroImage?.width || '360px' , height : layout?.heroImage?.height || 'auto'  }} src={layout?.heroImage?.url} alt="Hero Image" />
          </div>
                  </div>
          }
              { layout?.speakersFlag &&
              <div>
               { layout?.speakersFlag &&
  <div>
    <h3 style={{fontWeight: 'bold', color: '#003366', display: 'flex', alignItems: 'center' , margin: '0px'}}>
      Presenters:
      {!routerUrl.includes('view-lp') && !routerUrl.includes('preview') && (
       <FaCirclePlus
  style={{ color: "green", cursor: "pointer", marginLeft: "8px" }}
  onClick={() => setShowSpeakerPopup(true)}
/>
      )}
    </h3>

  
  </div>
}
             
              
          {layout?.speakers?.map((speaker, index) => (
  <div className="flex align-items-center" key={index}>
    {!routerUrl.includes('view-lp') && !routerUrl.includes('preview') && (
    <FaCircleMinus
      style={{ color: "red", cursor: "pointer", marginRight: "12px" }}
      onClick={() => {
        const updatedSpeakers = layout.speakers.filter((_, i) => i !== index);
        const updatedLayout = { ...layout, speakers: updatedSpeakers };
        setLayout(updatedLayout);
        dispatch(setLPDetails({ lplayout: updatedLayout }));
      }}
    />)}
    <div className="presenter-section">
      <img
        src={speaker.imageUrl}
        alt={speaker.name}
      />
      <div className="presenter-details" style={{position: 'relative', top: '0px'}}>
        <div className="presenter-name">{speaker.name}</div>
        <div className="presenter-role">{speaker.role}</div>
      </div>
    </div>
  </div>
))}
               
                </div>
              }   
                </div>
              </div>
              <div className="col-6">
                {layout?.formDisclaimer && layout?.formDisclaimer?.text?.trim() && (
                <div className="text-center">
                <p className={`beckersTextAboveTitle ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FORM_TITLE')) : undefined} style={{ color: layout?.formDisclaimer?.textColor }}>{layout?.formDisclaimer?.text}</p>
                </div>
                )}
                {!layout?.formDisclaimer?.text?.trim() && editMode &&  (
                <div className={`no-form-title beckersTextAboveTitle text-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={() => handleClick('FORM_TITLE')}>
                  Note: Add information above the form if needed.
              {editMode && <FaCirclePlus onClick={() => handleClick('FORM_TITLE')} className='mt-3' style={{ color: "green" ,position: 'relative', top : '2px' , marginLeft : '5px'}} />}
                </div>
              )}

              
                 <div id="formBC" style={{marginTop : '0px' , padding : '15px'}}>
                          <div className="text-center">
                            <div style={{ color: layout?.formDisclaimer?.textColor , backgroundColor: layout?.formDisclaimer?.backgroundColor , padding : '12px',margin : '0' , padding : '0' }}>
                
                            {/* <h2 style={{ color: layout?.formDisclaimer?.textColor ,  padding : '18px' }}> <span className={` ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FORM_TITLE')) : undefined} style={{ color: layout?.formDisclaimer?.textColor }}>{layout?.formDisclaimer?.text}</span>   {itemFields.length === 0 && editMode && <FaCirclePlus onClick={() => handleAdd()} className='mt-3' style={{ color: "green" }} />}</h2> */}
                            </div>

                            
                            <form class="form-id-lp-BC" onSubmit={handleSubmit(onFormSubmit)}>
                
                              {(routerUrl.includes('preview') || routerUrl.includes('view-lp')) &&
                              
                              <div>
                                  <div className = 'row mb-bc-20'>
                                                    <div className = 'col-6' style={{padding: '0px 24px'}}>
                                                         <label className='field-label-bc'>First Name *</label>
                                                          <span>
                      
                          <InputText id="text"  required/>
                        </span>
                                                    </div>
                                                    <div className = 'col-6' style={{padding: '0px 24px'}}>
                                                         <label className='field-label-bc'>Last Name *</label>
                                                          <span>
                      
                          <InputText id="text"   required/>
                        </span>
                                                    </div>
                                                  </div>
                              {
                                itemFields &&
                                itemFields.map((item, index) => <div key={item.id}> {getField(item, index)}</div >)
                              }
                              </div>
                              }
                
                              {(routerUrl.includes('create-lp') || routerUrl.includes('edit-lp')) &&
                              <DragDropContext onDragEnd={handleDragEnd}>
                                      <Droppable droppableId="list">
                                          {(provided) => (
                                              <div className="custom-cursor" {...provided.droppableProps} ref={provided.innerRef}>
                                                  <div className = 'row' style={{marginBottom : '20px'}}>
                                                   <div className = 'col-6' style={{padding: '0px 24px'}}>
                                                         <label className='field-label-bc'>First Name *</label>
                                                          <span>
                      
                          <InputText id="text"   />
                        </span>
                                                    </div>
                                                    <div className = 'col-6' style={{padding: '0px 24px'}}>
                                                         <label className='field-label-bc'>Last Name *</label>
                                                          <span>
                      
                          <InputText id="text"  />
                        </span> <span>{itemFields.length === 0 && editMode && <FaCirclePlus onClick={() => handleAdd()} className='mt-3' style={{ color: "green",cursor : 'pointer' }} />}</span>
                                                    </div>
                                                  </div>
                                                  {itemFields.map((item, index) => (
                                                      <Draggable style={{cursor : 'move'}} key={item.id} draggableId={item.id} index={index}>
                                                          {(provided) => (
                                                              <div  ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                              
                                                              {/* {item.type !== 'check' &&
                                                            <div>
                                                            <label className='field-label'>{item?.label}</label>
                                                        </div>
                                                              }  */}
                                                                  <div>{getField(item, index)}</div>
                                                              </div>
                                                          )}
                                                      </Draggable>
                                                  ))}
                                                  {provided.placeholder}
                                              </div>
                                          )}
                                      </Droppable>
                                  </DragDropContext>
                              }
                    {itemFields.length > 0 &&
                              <div className={`flex justify-content-left ${editMode ? "u-hover--sparkle" : ""}`}   onClick={editMode ? (() => handleClick('ACTION_BTN')) : undefined}>
                                <Button label={layout?.actionButton?.text} style={{ marginLeft : '24px' , backgroundColor: layout?.actionButton?.backgroundColor || "red", color: layout?.actionButton?.textColor || 'white' , marginTop : '20px'}} type="submit" outlined />
                              </div>
                }
                            </form>
                          </div>
                       
                    
                          </div>
                              <div id="con-msg-div" className="con-msg" style={{display: 'none'}}>
                <div className="webinar-box">
    <p>Thank you for registering for the webinar.</p>

    <h3 style={{color: "#003366" }}>{layout?.title?.text}</h3>
{(layout?.webinarType === 'liveWebinar' && layout?.liveWebinarTitle !== null) && (
                    <h3 style={{color: "#003366" }}>{layout?.liveWebinarTitle}</h3>
                  )}

    
<p>If you are unable to attend the live webinar, the on-demand version will be available within 72 hours.</p>
    <p>If you have any questions, please email <a href="mailto:webinarinfo@beckershealthcare.com">webinarinfo@beckershealthcare.com</a>.</p>
</div>
              </div>
              </div>
            </div>
            <hr style={{border:'1px solid #e1dddd'}}></hr>
            <div className= {`row footerDiv justify-content-center ${editMode ? "u-hover--sparkle" : ""}`} style={{marginTop:'30px'}} onClick={editMode ? (() => handleClick('FOOTER_CONTENT')) : undefined}>
             <MarkupViewer htmlString={layout?.footerContent}></MarkupViewer>
            </div>
          </div>
          {viewUploader && (
            <FileUploader
              open={viewUploader}
              handleCloseUploader={handleCloseUploader}
            ></FileUploader>
          )}
          {viewEditor && (
            <MarkupChanger
              open={viewEditor}
              text={markup}
              isWebinarEnabled={layout.isWebinar}
              webinarTitleVal={layout.webinarTitle}
              durationVal={layout.duration}
              handleCloseEditor={handleCloseEditor}
              webinarTypeBC={layout.webinarType}
              liveWebinarTitleBC={layout.liveWebinarTitle}
              speakersFlagBC={layout.speakersFlag}
            ></MarkupChanger>
          )}
          {viewFormBuilder && (
            <FormBuilder
              open={viewFormBuilder}
              data={markup}
              handleCloseBuilder={handleCloseBuilder}
            ></FormBuilder>
          )}
          {viewLayoutChanger && (
            <LayoutChanger
              open={viewLayoutChanger}
              data={content}
              handleCloseLayoutChanger={handleCloseLayoutChanger}
            ></LayoutChanger>
          )}
          {showSpeakerPopup && (
 <Speaker
  open={showSpeakerPopup}
  onClose={() => setShowSpeakerPopup(false)}
  onSave={(speakerData) => {
    const updatedSpeakers = [...(layout.speakers || []), speakerData];
    const updatedLayout = { ...layout, speakers: updatedSpeakers };
    setLayout(updatedLayout); // Update local state
    dispatch(setLPDetails({ lplayout: updatedLayout })); // Update Redux store
    setShowSpeakerPopup(false);
  }}
/>
)}
        </>
      );
    
}

export default BeckersTemplate
